import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        form: '=',
        formModel: '='
    },
    template: `
        <a class="btn main small" ng-click="vm.manageLanguages(vm.formModel, vm.form)">{{ 'general.Manage translations' | translate }}</a>
    `
})
export default class {
    constructor (ModalService, FormResource) {
        this.ModalService = ModalService;
        this.FormResource = FormResource;
    }

    manageLanguages (formModel, form) {
        return this.ModalService.open({
            animation: true,
            template: `
                <modals-forms-translation form-model="vm.formModel" update-form="vm.form" cancel="vm.$uibModalInstance.dismiss()"
                    update="vm.update()"
                    class="wrapper"></modals-forms-translation>
                `,
            size: 'full',
            controller ($uibModalInstance, FormResource) {
                this.$uibModalInstance = $uibModalInstance;
                this.formModel = formModel;
                this.form = form;
                this.FormResource = FormResource;
                this.update = () => {
                    this.$uibModalInstance.close();
                };
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/forms/translation/index.js